import Image from 'next/image';
import { LinkProps } from 'next/link';
import React, { forwardRef } from 'react';
import { Hotel } from '@/entities/hotel';
import Link from '@/shared/components/shared/Link';
import Typografed from '../Typografed';

export type Props = {
    cardInfo: Hotel;
    tag?: keyof JSX.IntrinsicElements | typeof Link;
} & Partial<LinkProps>;

const HotelCard = forwardRef<HTMLDivElement, Props>(({ cardInfo, tag = 'div', ...props }, ref) => {
    const { image, name, address, distance, rating, link } = cardInfo;
    const Component = link ? Link : tag;

    const linkProps = link
        ? {
              href: link,
              target: '_blank',
              rel: 'noreferrer nofollow',
          }
        : {};

    return (
        <div className="hotel-image__item">
            <Component {...linkProps} {...props} ref={ref}>
                <div className="hotel-image">
                    <Image
                        src={image.src}
                        className="hotel-image__img responsive__item"
                        height={image.height}
                        width={image.width}
                        alt={image.alt || ''}
                        sizes="(max-width: 1199px) 100vw, 30vw"
                    />
                    {rating && (
                        <div className="hotel-image__stars">
                            <span className="text-l">{rating}</span>
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 0.5L7.34708 4.6459H11.7063L8.17963 7.2082L9.52671 11.3541L6 8.7918L2.47329 11.3541L3.82037 7.2082L0.293661 4.6459H4.65292L6 0.5Z"
                                    fill="#0066F6"
                                />
                            </svg>
                        </div>
                    )}
                    <div className="hotel-image__content">
                        {name && (
                            <p className="hotel-image__title text-xl">
                                <Typografed>{name}</Typografed>
                            </p>
                        )}
                        {address && (
                            <p className="hotel-image__address text-m">
                                <Typografed>{address}</Typografed>
                            </p>
                        )}
                        {distance && (
                            <p className="hotel-image__distance text-m">
                                <Typografed>{distance}</Typografed>
                            </p>
                        )}
                    </div>
                </div>
            </Component>
        </div>
    );
});

HotelCard.displayName = 'HotelCard';

export default HotelCard;
